<template>
    <div class="userDetail">
        <el-form ref="form" :model="user" label-width="80px" class="userForm">
            <el-form-item label="账号">
                <el-input v-model="user.username" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input v-model="user.real_name"></el-input>
            </el-form-item>
            <el-form-item label="电话">
                <el-input v-model="user.tel"></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
                <el-input v-model="user.email"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-radio v-model="user.status" :label="1">在职</el-radio>
                <el-radio v-model="user.status" :label="2">离职</el-radio>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">确定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    data(){
        return {
            user: {
                username: null,
                real_name: null,
                tel: null,
                email: null,
                status: null,
            },
        }
    },
    mounted(){
        let userId = this.$route.params.user_id
        let _this = this
        this.$axios.get('/user/'+ userId)
        .then(res => {
            if (res.status === 1) {
                _this.user = res.data
            }
        })
    },
    methods: {
        onSubmit(){
            let userId = this.$route.params.user_id
            if (!this.user.real_name) {
                this.$message.error('姓名不能为空')
                return false
            } else if (!this.user.tel) {
                this.$message.error('电话不能为空')
                return false
            } else if (!this.user.email) {
                this.$message.error('邮箱不能为空')
                return false
            }
            this.$confirm('确认保存修改？')
            .then(() => {
                this.$axios.put(`/user/${userId}/`, this.user)
                .then(res => {
                    if (res.status === 1) {
                        this.$message.success('修改成功')
                    }
                })
            })
            .catch((res) => {
                this.$message.info('已取消修改')
                console.log(res)
            })
        }
    }
}
</script>
<style lang="less" scoped>
.userDetail{
    width: 100%;
    .userForm{
        width: 50%;
        margin: 50px auto;
    }
}
</style>